module.exports = __webpack_public_path__ + "static/media/skipModalBackground.1fa34147.png";